import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  selectAccommodation: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 24
  },
  filterButton: {
    marginTop: 24,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  filterContainer: {
    borderRadius: 4,
    padding: '24px 42px 24px 42px',
    marginBottom: 16,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)'
  },
  skeletonContainer: { width: '100%' },
  skeleton: { width: '100%', height: 60, marginBottom: 20 },
  skeletonRow: { width: '100%', height: 40 },
  refreshButton: {
    marginRight: 10
  },
  timePicker: {
    marginTop: 30
  },
  filters: {
    display: 'grid',
    width: '100%',
    alignItems: 'center',
    gap: 20,
    gridTemplateColumns: '2fr 1fr'
  },
  table: {}
}))

export default useStyles
